import React from 'react';

const SvgRenderer = ({ svgString }) => {
          return (
                <img src={`data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`} />
          )
};

export default SvgRenderer;
